import { DatetimeFormats } from './datetime-formats';

const DEFAULT_DATETIME_INPUT = {
  year: 'numeric', month: 'numeric', day: 'numeric',
  hour12: false, hour: "2-digit", minute: "2-digit" //, second: "2-digit"
}

export const NATIVE_DATETIME_FORMATS: DatetimeFormats = {
  parse: {
    dateInput: DEFAULT_DATETIME_INPUT,
  },
  display: {
    dateInput: DEFAULT_DATETIME_INPUT,
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};
